import React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { LinkLayout } from '../../../../../../Shared/Frontend/utils/links'
import type { ActionProps } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import type { LogoWallBlockClassNames, LogoWallItemProps } from './logoWallBlock.state'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const logoWallBlockClasses: LogoWallBlockClassNames = {
  // DEFAULTS
  block: 'block block--logowall',
  inview: 'inview',
  inner: 'block__inner ls-container--m ls-gutter ls-spacing--s',
  header: 'block__header',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro',
  content: 'block__content',
  footer: 'block__footer ls-clickables',
  clickableWrapper: 'block__action ls-clickable',
  clickablePrimary: 'block__button button button--primary',
  clickableSecondary: 'block__button link link--primary link--iconed',

  // BLOCK SPECIFIC
  logowall: 'logowall',
  logowallItem: 'logowall__item',
  logowallLink: 'logowall__link',
  logowallWrap: 'logowall__wrap',
  logowallVisual: 'logowall__visual',
  logowallImage: 'logowall__image'
}

export const LogoWallBlockLayout = {
  Inner: (props: {
    id?: string,
    children?: React.ReactNode,
    amountNested: number,
  }): JSX.Element => {
    const { amountNested, children, id } = props
    return (
      <div className={getClassNameModern(logoWallBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>{children}</div>
    )
  },
  Content: (props: {
    label?: string,
    title?: string,
    intro?: string,
    items: LogoWallItemProps[]
  } & ActionProps) => {
    const {
      label,
      title,
      intro,
      items,
      showPrimary,
      showSecondary,
      primaryAction,
      secondaryAction,
    } = props
    return (
      <>
        {(label || title || intro) && (
          <header className={getClassNameModern(logoWallBlockClasses, 'header', '')}>
            {label &&
              <p className={getClassNameModern(logoWallBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>{label}</p>
            }
            {title &&
              <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(logoWallBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>
            }
            {intro &&
              <div
                className={getClassNameModern(logoWallBlockClasses, 'intro', 'text--styled lead mb-3')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            }
          </header>
        )}

        {items && (
          <div className={getClassNameModern(logoWallBlockClasses, 'content', '')}>
            <LogoWallBlockLayout.LogoWall items={items} />
          </div>
        )}

        {(showPrimary || showSecondary) && (
          <footer className={getClassNameModern(logoWallBlockClasses, 'footer', 'pt-5')}>
            {showPrimary && primaryAction && primaryAction.title && primaryAction.url && (
              <div className={getClassNameModern(logoWallBlockClasses, 'clickableWrapper', 'd-block d-sm-inline-block')}>
                <SharedBlockLayout.Clickable
                  id='textPrimaryAction'
                  type='button'
                  link={primaryAction}
                  classNames={getClassNameModern(logoWallBlockClasses, 'clickablePrimary', 'btn btn-primary')}
                />
              </div>
            )}
            {showSecondary && secondaryAction && secondaryAction.title && secondaryAction.url && (
              <div
                className={getClassNameModern(
                  logoWallBlockClasses,
                  'clickableWrapper',
                  'd-block d-sm-inline-block ms-sm-3 mt-3 mt-sm-0'
                )}
              >
                <SharedBlockLayout.Clickable
                  id='textSecondaryAction'
                  type='link'
                  link={secondaryAction}
                  classNames={getClassNameModern(logoWallBlockClasses, 'clickableSecondary', 'btn btn-outline-primary')}
                  SVGIcon={{ iconId: "#icon--chevron-right", width: "7px", height:"11px" }}
                />
              </div>
            )}
          </footer>
        )}
      </>
    )
  },
  LogoWall: (props: { items: LogoWallItemProps[] }) => {
    const { items } = props
    return (
      <ul className={getClassNameModern(logoWallBlockClasses, 'logowall', '')}>
        {items.map((innerItem, index) => {
          return (
            <li
              key={`lwb-i-${index}`}
              className={getClassNameModern(logoWallBlockClasses, 'logowallItem', '')}
            >
              {innerItem.link && innerItem.link.url ? (
                <LinkLayout
                  link={innerItem.link}
                  className={getClassNameModern(logoWallBlockClasses, 'logowallLink', '')}
                >
                  <LogoWallBlockLayout.LogoWallItem item={innerItem} />
                </LinkLayout>
              ) : (
                <LogoWallBlockLayout.LogoWallItem item={innerItem} />
              )}
            </li>
          )
        })}
      </ul>
    )
  },
  LogoWallItem: (props: { item: LogoWallItemProps }) => {
    const { item } = props
    return (
      <div className={getClassNameModern(logoWallBlockClasses, 'logowallWrap', '')} title={item.name ? item.name : undefined}>
        <div className={getClassNameModern(logoWallBlockClasses, 'logowallVisual', '')}>
          {/* <SharedBlockLayout.ModernImageSrcSet
            image={item.logo}
            lazyload={true}
            priority={undefined}
            classNames={getClassNameModern(logoWallBlockClasses, 'logowallImage', '')}
            imageProportions={{
              width: '211',
              height: '119',
            }}
          /> */}
        </div>
      </div>
    )
  },
}
